export const MissingData = Object.freeze({
    NONE: '-',
    NO_DATA: 'No Data',
  });